export default {
  chooseLanguage: 'Selecciona el idioma en el que crearás tu recurso',
  chooseLanguagePlaceholder: 'Seleccionar idioma',
  chooseLanguageDesc: 'Elige un idioma para crear el recurso',
  resourceName: 'Nombre del recurso',
  resourceNamePlaceholder: 'Escribe el nombre del recurso',
  rhetoricalQuestion: 'Pregunta retórica',
  rhetoricalQuestionPlaceholder: 'Escribe la pregunta retórica',
  videoOrImage: 'Video o imagen de presentación',
  videoOrImagePlaceholder: 'Inserte el enlace o sube un archivo',
  benefits: 'Beneficios del recurso',
  benefitsPlaceholder: 'Escribe los beneficios del recurso',
  addLanguage: 'Agregar idioma',
  removeLanguage: 'Eliminar',
  removeLanguageTitle: '¿Estás seguro que quieres eliminar el idioma?',
  removeLanguageDesc: 'Al presionar Eliminar se borrará toda la información cargada en el idioma {locale}',
  uploadingFile: 'Subiendo...',
  uploadFile: 'Subir imagen',
  uploadFileError: 'Ha ocurrido un error al subir al archivo. Intente nuevamente',
  cancel: 'Cancelar',
  uploading: 'Subiendo...',
  isNecessarySelectALanguage: 'Es necesario elegir un idioma',
  errors: {
    title: 'El título es requerido'
  }
}

export const en = {
  chooseLanguage: 'Select the language in which you will create your resource',
  chooseLanguagePlaceholder: 'Select language',
  chooseLanguageDesc: 'Choose a language to create the resource',
  resourceName: 'Name of the resource',
  resourceNamePlaceholder: 'Type the name of the resource',
  rhetoricalQuestion: 'Rhetorical question',
  rhetoricalQuestionPlaceholder: 'Type the rhetorical question',
  videoOrImage: 'Presentation video or image',
  videoOrImagePlaceholder: 'Insert link or upload file',
  benefits: 'Benefits of the resource',
  benefitsPlaceholder: 'Type the benefits of the resource',
  addLanguage: 'Add language',
  removeLanguage: 'Delete',
  removeLanguageTitle: 'Are you sure you want to delete the language?',
  removeLanguageDesc: 'Pressing Delete will erase all the information loaded in the language {locale}',
  uploadingFile: 'Uploading...',
  uploadFile: 'Upload image',
  uploadFileError: 'An error occurred while uploading the file. Please try again',
  cancel: 'Cancel',
  uploading: 'Uploading...',
  isNecessarySelectALanguage: 'It is necessary to choose a language',
  errors: {
    title: 'The title is required'
  }
}

export const ca = {
  chooseLanguage: 'Selecciona l\'idioma en el que crearàs el teu recurs',
  chooseLanguagePlaceholder: 'Seleccionar idioma',
  chooseLanguageDesc: 'Escull un idioma per crear el recurs',
  resourceName: 'Nom del recurs',
  resourceNamePlaceholder: 'Escriu el nom del recurs',
  rhetoricalQuestion: 'Pregunta retòrica',
  rhetoricalQuestionPlaceholder: 'Escriu la pregunta retòrica',
  videoOrImage: 'Vídeo o imatge de presentació',
  videoOrImagePlaceholder: 'Insereix l\'enllaç o carrega un arxiu',
  benefits: 'Beneficis del recurs',
  benefitsPlaceholder: 'Escriu els beneficis del recurs',
  addLanguage: 'Afegir idioma',
  removeLanguage: 'Eliminar',
  removeLanguageTitle: 'Estàs segur que vols eliminar l\'idioma?',
  removeLanguageDesc: 'En prémer Eliminar s\'esborrarà tota la informació carregada a l\'idioma {locale}',
  uploadingFile: 'Carregant...',
  uploadFile: 'Carregar imatge',
  uploadFileError: 'S\'ha produït un error carregant l\'arxiu. Torna-ho a intentar',
  cancel: 'Cancelar',
  uploading: 'Carregant...',
  isNecessarySelectALanguage: 'És necessari escollir un idioma',
  errors: {
    title: 'El títol és requerit'
  }
}
